import React from "react";

const RejectedPage = () => {
  return <div>RejectedPage</div>;
};

export default RejectedPage;
